import { Component, Input, AfterViewInit } from '@angular/core';
import Chart, { Plugin } from 'chart.js/auto';
import { SharedModule } from 'src/app/private/shared/shared.module';

@Component({
  selector: 'app-pie-chart',
  imports: [SharedModule],
  templateUrl: './pie-chart.component.html',
  styleUrls: ['./pie-chart.component.scss'] // ✅ corrected
})
export class PieChartComponent implements AfterViewInit {
  @Input() data!: Record<string, number>;
  @Input() id!: string;
  @Input() Title!: string;

  color1: string = '#104358';
  color2: string = '#1E73AC';

  ngAfterViewInit() {
    if (this.id === 'total_income' || this.id === 'total_income_opto') {
      this.color1 = '#1876CC';
      this.color2 = '#F0950C';
    }

    const canvas = document.getElementById(this.id) as HTMLCanvasElement;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    if (!ctx) return;

    // Destroy old chart if exists
    const chartStatus = Chart.getChart(this.id);
    if (chartStatus) {
      chartStatus.destroy();
    }

    const labels: string[] = [];
    const values: number[] = [];
    const colors: string[] = [];

    if (this.data) {
      for (const key in this.data) {
        labels.push(key);
        values.push(this.data[key]);
        colors.push(this.getRandomColorHex());
      }
    }

    const chart = new Chart(ctx, {
      type: 'doughnut',
      data: {
        labels,
        datasets: [
          {
            label: '',
            data: values,
            backgroundColor: [
              this.color1,
              this.color2,
              '#20A6FF',
              '#74A3C3',
              ...colors // ✅ added randoms after defaults
            ],
            borderWidth: 1
          }
        ]
      },
      plugins: [this.customLegendPlugin(labels, values)],
      options: {
        plugins: {
          legend: { display: false }
        },
        responsive: true,
        scales: {
          x: {
            border: { display: false },
            grid: { display: false },
            ticks: { display: false }
          },
          y: {
            border: { display: false },
            grid: { display: false },
            ticks: { display: false }
          }
        }
      }
    });
  }

  // ✅ Moved legend plugin to method
  customLegendPlugin(labels: string[], values: number[]): Plugin {
    const self = this;
    return {
      id: 'customLegend',
      afterInit(chart) {
        if (chart.canvas.id !== self.id) return;

        const ul = document.createElement('ul');
        ul.style.listStyle = 'none';
        ul.style.display = 'flex';
        ul.style.flexDirection = 'column';
        ul.style.position = 'absolute';
        ul.style.top = '35px';
        ul.style.right = '0px';
        ul.style.alignItems = 'flex-start';
        ul.style.fontSize = '16px';
        ul.style.gap = '12px';

        labels.forEach((label, i) => {
          ul.innerHTML += `
            <li>
              <div style="display: flex; flex-direction: row; padding: 5px;">
                <div style="width: 17px; margin-right: 12px; height:19px; 
                    margin-top: 5px; padding:5px; background-color: ${(chart.data.datasets[0].backgroundColor as string[])[i]};">
                </div>
                <div style="color:gray; margin-top:4px; display:flex; gap:15px">
                  <div style="margin-left: 11px; color:#000">${values[i]}</div>
                  ${label}
                </div>
              </div>
            </li>
          `;
        });

        const legend = document.getElementById('legend_' + self.id) as HTMLElement;
        if (legend) {
          legend.innerHTML = '';
          legend.appendChild(ul);
        }
      }
    };
  }

  getRandomColorHex(): string {
    const randomColor = Math.floor(Math.random() * 16777215).toString(16);
    return "#" + randomColor.padStart(6, "0");
  }
}
